import styles from './Engagement.module.css';
import { ClientInfluencerAccount } from '../../helpers';
import { ComponentProps, useState } from 'react';
import cn from 'classnames';
import TiktokPerformance from './Performance/TikTokPerformance';
import InstagramPerformance from './Performance/InstagramPerformance';
import InstagramTopPosts from './TopPosts/InstagramTopPosts';
import TiktokTopPosts from './TopPosts/TikTokTopPosts';
import { Card, DateRange } from '@round/creatorbase-ui';
import DateRangePicker from './Performance/DateRangePicker';

type Props = {
    account: ClientInfluencerAccount | undefined | null;
    isLoading?: boolean;
} & ComponentProps<'div'>;

const Engagement = ({ account, isLoading, className, ...props }: Props) => {
    const [dateRange, setDateRange] = useState<DateRange>();
    const platform = account?.platform;
    const userId = account?.creatorbase_user_id;

    const Performance = platform === 'tiktok' ? TiktokPerformance : InstagramPerformance;
    const TopPosts = platform === 'tiktok' ? TiktokTopPosts : InstagramTopPosts;

    return (
        <div className={cn(styles.container, className)} {...props}>
            <Card size="sm" variant="borderless" className={styles.cardContainer}>
                <Card.Header className={cn(styles.cardHeader, styles.performanceHeader)}>
                    <Card.Title>Performance</Card.Title>
                    <DateRangePicker dateRange={dateRange} onDateRangeChange={setDateRange} />
                </Card.Header>
                <Card.Content className={styles.cardContent}>
                    <Performance userId={userId} isLoading={isLoading} dateRange={dateRange} />
                </Card.Content>
            </Card>

            <TopPosts account={account} isLoading={isLoading} />
        </div>
    );
};

export default Engagement;
